import { Pipe, PipeTransform } from '@angular/core';
import { Language } from '@lemonsolutions/models';
import { UtilsService } from '@ls-commons/utils';

@Pipe({
  name: 'infoLanguage',
  standalone: true,
})
export class InfoLanguagePipe implements PipeTransform {
  constructor(private utilsService: UtilsService) {}

  transform(value: string): Language | undefined {
    const language = this.utilsService.getLanguage(value);
    return language;
  }
}
